import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/products/${id}?fromAdmin=true`)
    },
    list(params) {
        params.fromAdmin = true
        return Vue.axios.get(`/products`, {params})
    },
    report(params) {
        params.fromAdmin = true
        return Vue.axios.get(`/products/report`, {params})
    },
    massEdit(act, params){
        return Vue.axios.post(`/products/mass-edit/${act}`, params)
    },
    updateSort(data) {
        return Vue.axios.post(`/products/sort/update`, data)
    },
    remove(id){
        return Vue.axios.get(`/products/remove/${id}`)
    },
    restore(id){
        return Vue.axios.get(`/products/restore/${id}`)
    },
    checkConstructor(){
        return Vue.axios.get(`/constructor/check`)
    },
    toggleCheckConstructor(){
        return Vue.axios.get(`/constructor/check/toggle`)
    },
    addToConstructor(ids) {
        return Vue.axios.post(`/products/constructor/add`, ids)
    },
    copy(productId) {
        return Vue.axios.post(`/products/copy`, {productId})
    },
    updateModifierRelation(productId, itemId, params){
        return Vue.axios.post(`/products/update/${productId}/modifiers/${itemId}`, params)
    },
    updateProductModifiersSort(id, data){
        return Vue.axios.post(`/products/${id}/modifiers/sort/update`, data)
    },
    updateProductModifiersEnabled(id, data){
        return Vue.axios.post(`/products/${id}/modifiers/enabled/update`, data)
    },
    listConstructor() {
        return Vue.axios.get(`/products/constructor`)
    },
    sauces(params) {
        return Vue.axios.get(`/products/get-sauces`, {params})
    },
    update(id, data) {
            return Vue.axios.post(`/products/update/${id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },
    updateSetProducts(id, data) {
        return Vue.axios.post(`/products/update/${id}/set-products`, data)
    },
    removeFromConstructorMass(params){
        return Vue.axios.get(`/products/remove-from-constructor`, {params})
    },
    findByName(params){
        return Vue.axios.get(`/products/find-by-name`, {params})
    },
    create(data) {
        return Vue.axios.post(`/products/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updatePopularProducts(data) {
        return Vue.axios.post(`/products/popular/update`, data)
    },
    updatePopularProductsSort(data) {
        return Vue.axios.post(`/products/popular/sort/update`, data)
    },
    getPopularRelation(params) {
        return Vue.axios.get(`/products/popular/relation`, {params})
    },
    listByCategory(params) {
        return Vue.axios.get(`/products-by-category` + (params && params.withChild ? '?withChild=true' : '') , {params})
    },
    updateModifiers(id, data) {
        return Vue.axios.post(`/products/update/${id}/modifiers`, data)
    },
    updateModifiersGroup(id, data) {
        return Vue.axios.post(`/products/update/${id}/modifiers-group`, data)
    },
    removeModifierRelation(id){
        return Vue.axios.get(`/products/remove/modifier/${id}`)
    }
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
